import React from 'react';
import PropTypes from 'prop-types';

const renderPlayerInfo = (block, flagText, title) => (
  <div className={`${block}__player-info`}>
    {
      flagText ? (
        <span className={`${block}__player-info-flag`}>
          <span className={`${block}__player-info-flag-dot`} />
          <span className={`${block}__player-info-flag-text`}>{flagText}</span>
        </span>
      ) : null
    }
    <span className={`${block}__player-info-text`}>{title}</span>
  </div>
);

const PlayerInfo = ({
  block,
  flagText,
  title,
  url,
}) => {
  if (!title) return null;

  return (
    <>
      {
        url
          ? <a href={url}>{renderPlayerInfo(block, flagText, title)}</a>
          : renderPlayerInfo(block, flagText, title)
      }
    </>
  );
};

PlayerInfo.propTypes = {
  block: PropTypes.string,
  flagText: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
};

PlayerInfo.defaultProps = {
  block: null,
  flagText: null,
  title: null,
  url: null,
};

export default PlayerInfo;
